import { gql } from "@apollo/client";

export const MEASURES_CATALOG_QUERY = gql`
  query MeasuresCatalog($filters: MeasureCatalogFilters, $first: Int, $offset: Int, $sort: String) {
    measureSummary(filters: $filters) {
      totalCount
      publishedCount
      toReviewCount
      indicatorCount
      territoryCount
      periodMin
      periodMax
      anomalyCount
    }
    measureFilterOptions(filters: $filters) {
      services {
        id
        libelle
        categorie
        prioritaire
      }
      territories {
        id
        kind
        label
      }
      empriseKinds
      measureUnits
      qualites
      measureStatuses
      years
      sources
      indicateurs {
        id
        libelle
      }
      dimensions {
        code
        label
      }
    }
    measureAnalytics(filters: $filters) {
      byService {
        label
        value
      }
      byTerritory {
        label
        value
      }
      byStatus {
        label
        value
      }
      byYear {
        label
        value
      }
    }
    measureCatalog(filters: $filters, first: $first, offset: $offset, sort: $sort) {
      totalCount
      nodes {
        id
        value
        unit
        indicateurId
        indicateurLibelle
        serviceId
        serviceLibelle
        empriseKind
        territoryId
        territoryLabel
        periodStart
        periodEnd
        dimensions {
          type
          code
          label
        }
        method
        quality
        status
        confidence
        source
        page
        provenanceId
      }
    }
  }
`;
